const ORG_KEY = 'cc.selectedOrganisationId';
const PLAN_KEY = 'cc.selectedPlanId';

function read(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key, value) {
  try {
    if (value == null || value === '') sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, String(value));
  } catch {
    // Private mode / blocked storage — selection still works for the current page.
  }
}

export function getStoredOrganisationId() {
  return read(ORG_KEY);
}

export function setStoredOrganisationId(organisationId) {
  write(ORG_KEY, organisationId);
}

export function getStoredPlanId() {
  return read(PLAN_KEY);
}

export function setStoredPlanId(planId) {
  write(PLAN_KEY, planId);
}

export function clearSessionContext() {
  write(ORG_KEY, null);
  write(PLAN_KEY, null);
}
